import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"
import { getParentStudents, type ParentStudent } from "../../../service/parent-portal"
import { all_routes } from "../../router/all_routes"

const routes = all_routes

const ParentPortalDashboard = () => {
  const [students, setStudents] = useState<ParentStudent[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getParentStudents()
      .then((r) => setStudents(r.data.items))
      .catch(() => toast.error("Failed to load students"))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="mb-4">
          <h3 className="page-title mb-1">My Students</h3>
          <p className="text-muted mb-0">Click a student to view their published report cards.</p>
        </div>

        {loading ? (
          <p className="text-muted">Loading…</p>
        ) : students.length === 0 ? (
          <div className="card">
            <div className="card-body text-center py-5 text-muted">
              No students linked to your account. Please contact the school office.
            </div>
          </div>
        ) : (
          <div className="row g-3">
            {students.map((s) => (
              <div key={s.id} className="col-md-4 col-sm-6">
                <Link
                  to={routes.parentStudentCards.replace(":studentId", s.id)}
                  className="card text-decoration-none hover-shadow h-100"
                >
                  <div className="card-body">
                    <div className="d-flex align-items-center gap-3 mb-2">
                      <div
                        className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white fw-bold"
                        style={{ width: 44, height: 44, flexShrink: 0 }}
                      >
                        {s.full_name.charAt(0).toUpperCase()}
                      </div>
                      <div>
                        <div className="fw-semibold">{s.full_name}</div>
                        <div className="text-muted small">GR: {s.gr_number || "—"}</div>
                      </div>
                    </div>
                    {s.fathers_name && (
                      <div className="text-muted small">Father: {s.fathers_name}</div>
                    )}
                    <div className="mt-2 text-primary small">View report cards →</div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default ParentPortalDashboard
